import { mockInstance, withDelay } from '../../../../api/axiosInstance.mock';

import { SIGNATURE_CONFIRMATION_ENDPOINT } from '../../apiEndPoints';
import { dataCoEmprunteur1 as sessionMockData } from '../../contexte/useSessionApi/useSessionApi.mock';

const endPoint = SIGNATURE_CONFIRMATION_ENDPOINT.replace(
    /{idDemande}/g,
    String(sessionMockData?.contextePret?.idDemande)
);

export const useSignatureConfirmationApiMock = (): any => {
    const url = new RegExp(`${endPoint}`);

    mockInstance.onPut(url).reply(withDelay([200, null], 200));
};
